module.exports = ".page-not-found{color:azure}\n"